import axios from "axios";

import { AI_BACKEND_URL_AUDIO_QUALITY_CHECK } from "@/constants/constants";
import { AudioQualityBackendResult } from "@/types/defs/audioQuality/audioQualityCheck";
import { parseAudioQualityCheckFromBackend } from "@/utils/audio/quality/parseAudioQualityCheckFromBackend";

export const postAudioQualityCheck = async (
  formData: FormData,
  signal: AbortSignal | null
): Promise<AudioQualityBackendResult> => {
  const response = await axios.post(
    AI_BACKEND_URL_AUDIO_QUALITY_CHECK,
    formData,
    {
      signal: signal === null ? undefined : signal,
    }
  );

  return parseAudioQualityCheckFromBackend(response.data);
};
